const SET_ASSIGNMENT_CLAUSE_DETAILS = "SET_ASSIGNMENT_CLAUSE_DETAILS";
const SAVE_ASSIGNMENT_CLAUSE_DETAILS = "SAVE_Assignment_Clause_DETAILS";

export { SET_ASSIGNMENT_CLAUSE_DETAILS, SAVE_ASSIGNMENT_CLAUSE_DETAILS };
